import '../Enum'
import 'Dict/Data/DynDicts'
import 'Spatial/Data/Classes'

/** @namespace Accounting */
NS("Accounting");

/**
 * @class
 * @extends Enum
 */
Accounting.AttributeOption = Static(Enum, /** @lends Accounting.AttributeOption */ {
    // публичные опции, достпны в UI
    MaxLength: "maxlength",
    MaxValue: "max",
    MinValue: "min",
    Precision: "precision",
    Dict: "dict",
    Layer: "layer",
    MaxQuantity: 'maxq',
	MaxSize: 'maxs',
    FileType: 'filetype',
    IsName: "isname",
    Unit: "unit",
    Kind: 'kind',
    Multiple: 'multi',
    SearchAttribute: 'searchAttribute',
    // скрытые служебные опции
    TargetPrefix: 'targetPrefix',
    HtmlPlaceholder: 'htmlPlaceholder',
    DictRecordsSource: 'dictRecordsSource',
    DictMasterIds: 'dictMasterIds',
    ReferenceSource: 'referenceSource',
    CreateReferenceHelper: 'createReferenceHelper',
    AfterRenderCreateReferenceForm: 'afterRenderCreateReferenceForm',
    ExcludedReferenceAttributeTypes: 'excludedReferenceAttributeTypes',
    ReferenceColumnsNum: 'referenceColumnsNum',
    ReferenceAttributes: 'referenceAttributes',
    Sequence: 'sequence',
    Template: 'template',
    Schedule: 'schedule',
    Editable: 'editable',
	LineCount: 'linecount',

    title(value) {
        switch (value) {
            case this.LineCount:
                return "Количество строк";
            case this.MaxLength:
                return "Максимальная длина";
            case this.MaxValue:
                return "Максимальное значение";
            case this.MinValue:
                return "Минимальное значение";
            case this.Precision:
                return "Точность";
            case this.Dict:
                return "Справочник значений";
			case this.Layer:
				return "Слой";
            case this.MaxQuantity:
                return "Максимальное число элементов";
            case this.MaxSize:
                return "Максимальный размер (Мб) элемента";
            case this.FileType:
				return "Тип файлов";
            case this.IsName:
                return "Является заголовком";
            case this.Unit:
                return "Еденица измерения";
            case this.Kind:
                return 'Вид учета';
            case this.Multiple:
                return "Множественное значение";
            case this.Sequence:
                return 'Поля участвующие в генерации';
            case this.Template:
                return 'Шаблон';
            case this.Schedule:
                return 'Ссылка на расписание';
            case this.SearchAttribute:
                return 'Атрибут для поиска';
            case this.Editable:
                return 'Редактирование';
            default:
                return this.ParentCall();
        }
    },
    /**
     * @param {string} value
     * @param {UI.Widget.Form} instance
     * @returns {Object} Returns basic control attributes for option
     */
    control(value, instance) {
        switch (value) {
            case this.IsName:
            case this.Multiple:
            case this.Editable:
                return {
                    type: 'checkbox',
                    target: value,
                    'path-customizer': 'Object',
                };
            case this.Dict:
                return {
                    type: "data-autocomplete",
                    target: value + 'name',
                    source: 'Dict.Data.DynDicts',
                    columns: 'name',
                    column: 'name',
                    bind: value + ':id',
                    strict: true,
                    'path-customizer': 'Object',
                };
            case this.Layer:
                return {
                    type: "data-autocomplete",
                    target: value + 'name',
                    source: 'Spatial.Data.Classes',
                    columns: 'uid,name',
                    column: 'name',
                    bind: value + ':id',
                    strict: true,
                    'path-customizer': 'Object',
                };
            case this.FileType:
                return {
					type: 'select',
					target: value,
                    source: 'fileTypes',
					"show-empty": true
                };
            case this.Kind:
                return {
                    type: 'data-autocomplete',
                    target: value + 'name',
                    source: 'Accounting.Data.Kinds',
                    columns: 'id,name',
                    column: 'name',
                    bind: value + ':id',
                    strict: true,
                    'path-customizer': 'Object'
                };
            case this.Sequence:
                if(instance.item.id)
                    return {
                        type: 'popup-select',
                        multiple: true,
                        target: value,
                        'value-key': "code",
                        source: 'sourceSequenceType',
                        filter: {kindid: instance.item.kindid},
                        'view-only': true
                    };
                return {
                    type: 'popup-select',
                    multiple: true,
                    target: value,
                    'value-key': "code",
                    source: 'sourceSequenceType',
                    filter: {kindid: instance.item.kindid}
                };
            case this.Template:
                if(instance.item.id)
                    return {
                        type: "label",
                        target: value,
                    };
                return {
                    type: 'popup-input',
                    target: value,
                    'value-key': "id",
                    source: 'sourceTemplateType',
                    filter: {kindid: instance.item.kindid}
                };
            case this.Schedule:
                return {
                    type: 'popup-select',
                    multiple: false,
                    target: value,
                    'value-key': "id",
                    source: 'sourceSchedules',
                    columns: [{name: 'id', title: '#'}, {name: 'title', title:'Название'}],
                    valueKey: 'id'
                    //filter: {kindid: instance.item.kindid}
                };
            case this.SearchAttribute:
                return {
                    type: 'popup-select',
                    multiple: false,
                    target: value,
                    source: 'sourceAttributes',
                    'value-key': 'id',
                    'title-key': 'name',
                    columns: [{ name: 'id', title: '#' }, { name: 'name', title: 'Имя' }],
                    filter: {
                        ns: _.get(instance.item, 'options.layer', -1), // attr namespace
                        types: [ 1, 2, 3, 4 ] // text, date/datetime, numeric
                    }
                };
            case this.MaxLength:
            case this.MinValue:
            case this.MaxValue:
            case this.Precision:
            case this.Unit:
            case this.LineCount:
            default:
                return {
                    type: "text",
                    target: value,
                    'path-customizer': 'Object',
                };
        }
    }
});

